<template>
    <div
        class="modal show d-block"
        :id="'modal-encaissement-staff' + cartRowId"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="'modal-encaissement-staff' + cartRowId"
        aria-modal="true"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content rounded-24 overflow-hidden" style="margin-top: 100px;">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header">
                        <h3 class="block-title">Suivi de la vente</h3>
                        <div class="block-options">
                            <button
                                type="button"
                                class="btn-block-option"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal()"
                            >
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <div class="mb-4">
                            <label for="seller">Vente :</label>
                            <select class="form-select" name="seller_id" id="seller" @change="updateSellerId($event)">
                                <option value="">Aucun</option>
                                <option v-for="staff in staffs" :key="staff.id" :value="staff.id" :selected="sellerId == staff.id"
                                    >{{ staff.first_name }} {{ staff.last_name }}</option
                                >
                            </select>
                        </div>

                        <div class="mb-4">
                            <label for="practioner">Conseil :</label>
                            <select class="form-select" name="advised_id" id="practioner" @change="updateAdviserId($event)">
                                <option value="">Aucun</option>
                                <option
                                    v-for="staff in staffs"
                                    :key="staff.id"
                                    :value="staff.id"
                                    :selected="adviserId == staff.id"
                                    >{{ staff.first_name }} {{ staff.last_name }}</option
                                >
                            </select>
                        </div>
                    </div>
                    <input type="hidden" value="staff" name="type" id="type" />
                    <div class="block-content block-content-full text-center ">
                        <button type="button" class="btn btn-sm btn-primary text-light me-1 rounded-pill py-2 px-3" @click="editSeller()">Valider</button>
                        <button type="button"  class="btn btn-sm btn-alt-secondary me-1 rounded-pill py-2 px-3" @click="closeModal()">
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from './_core/ApiManager'
export default {
    props: ['cartRowId', 'sellerId', 'adviserId'],
    data: () => ({
        staffs: [],
        selectedSellerId: null,
        selectedAdviserId: null,
    }),
    async mounted() {
        await ApiManager.getAllStaffs().then(res => (this.staffs = res))
        this.selectedSellerId = this.sellerId
        this.selectedAdviserId = this.adviserId
    },
    methods: {
        async editSeller() {
            await ApiManager.editSeller(this.cartRowId, this.selectedSellerId, this.selectedAdviserId).then(() => {
                this.closeModal()
                window.location.reload()
            })
        },
        closeModal() {
            this.$emit('hide-staff-modal')
        },

        updateSellerId(event) {
            this.selectedSellerId = event.target.value
        },

        updateAdviserId(event) {
            this.selectedAdviserId = event.target.value
        },
    },
}
</script>

<style></style>
